import React from 'react';
import './SignalFeed.css';

interface SignalFeedProps {
  items: { id: string; text: string; ts: string }[];
}

const SignalFeed: React.FC<SignalFeedProps> = ({ items }) => {
  return (
    <div className="signal-feed">
      {items.length === 0 ? (
        <div className="signal-empty">No signals yet.</div>
      ) : (
        items.map((i) => (
          <div key={i.id} className="signal-item">
            <div className="signal-text">{i.text}</div>
            <div className="signal-time">{i.ts}</div>
          </div>
        ))
      )}
    </div>
  );
};

export default SignalFeed;
